import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "cookie-consent__text" }, [
  /*#__PURE__*/_createTextVNode(" Utilizamos cookies propias y de terceros para obtener datos estadísticos de la navegación de nuestros usuarios y mejorar nuestros servicios. Si acepta o continúa navegando, consideramos que acepta su uso. Puede cambiar la configuración u obtener más información "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/politica-tratamiento-datos/",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "cookie-consent__link"
  }, "aquí"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cookie-consent", { active: _ctx.isCookieActive }])
  }, [
    _hoisted_1,
    _createElementVNode("button", {
      class: "cookie-consent__button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.acceptCookies && _ctx.acceptCookies(...args)))
    }, " Aceptar ")
  ], 2))
}